import TagManager from "react-gtm-module";

export enum Language { de = 'de', fr = 'fr', it = 'it', en = 'en', lt = 'lt', lv = 'lv', et = 'et', fi = 'fi' }
export const DEFAULT_LANGUAGES: Language[] = [Language.de,Language.fr,Language.it,Language.en];

export const enum ActionType {
    FETCH_MAINCATEGORIES = 'avesco_client@FETCH_MAINCATEGORIES',
    FETCH_SPECIALOFFERSCOMPACTOVERVIEW = 'avesco_client@FETCH_SPECIALOFFERSCOMPACTOVERVIEW',
    FETCH_PRODUCTFAMILYICONS = 'avesco_client@FETCH_PRODUCTFAMILYICONS',
    FETCH_PRODUCTSBYFAMILYICONS = 'avesco_client@FETCH_PRODUCTSBYFAMILYICONS',
    FETCH_CONFIGURATORPRODUCT = 'avesco_client@FETCH_CONFIGURATORPRODUCT',
    CHECK_CONFIGURATION = 'avesco_client@CHECK_CONFIGURATION',
    FETCH_CONFIGURATION = 'avesco_client@FETCH_CONFIGURATION',
    DISMISS_CONFIGURATION = 'avesco_client@DISMISS_CONFIGURATION',
    START_LOGIN = 'avesco_client@START_LOGIN',
    LOGIN = 'avesco_client@LOGIN',
    LOGOUT = 'avesco_client@LOGOUT',
    SELECT_ACCOUNT = 'avesco_client@SELECT_ACCOUNT',
    CANCEL_LOGIN = 'avesco_client@CANCEL_LOGIN',
    RESET_LOGIN = 'avesco_client@RESET_LOGIN',
    REQUEST_PORTAL_ACCOUNT = 'avesco_client@REQUEST_PORTAL_ACCOUNT',
    START_SUBSCRIBE = 'avesco_client@START_SUBSCRIBE',
    SUBSCRIBE = 'avesco_client@SUBSCRIBE',
    CANCEL_SUBSCRIBE = 'avesco_client@CANCEL_SUBSCRIBE',
    START_RESETPASSWORD = 'avesco_client@START_RESETPASSWORD',
    RESETPASSWORD = 'avesco_client@RESETPASSWORD',
    CANCEL_RESETPASSWORD = 'avesco_client@CANCEL_RESETPASSWORD',
    RETRIEVE_COUNTRY_CODE = 'avesco_client@RETRIEVE_COUNTRY_CODE',
    FILTER_PRODUCTS = 'avesco_client@FILTER_PRODUCTS',
    TOGGLE_FILTER = 'avesco_client@TOGGLE_FILTER',

    BASKET_CHANGEPRODUCTTYPE = 'avesco_client@BASKET_CHANGEPRODUCTTYPE',
    BASKET_CHANGEOPTIONSELECTION = 'avesco_client@BASKET_CHANGEOPTIONSELECTION',
    BASKET_CHANGELEASINGSELECTION = 'avesco_client@BASKET_CHANGELEASINGSELECTION',
    BASKET_CHANGERENTSELECTION = 'avesco_client@BASKET_CHANGERENTSELECTION',
    BASKET_CHANGEFULLSERVICESELECTION = 'avesco_client@BASKET_CHANGEFULLSERVICESELECTION',
    BASKET_CHANGEEXTENDEDWARRANTYSELECTION = 'avesco_client@BASKET_CHANGEEXTENDEDWARRANTYSELECTION',
    BASKET_CHANGEQUICKCOUPLERSELECTION = 'avesco_client@BASKET_CHANGEQUICKCOUPLERSELECTION',
    BASKET_LOAD = 'avesco_client@BASKET_LOAD',

    CONTACT_FORMCHANGE = 'avesco_client@CONTACT_FORMCHANGE',
    CONTACT_FORMREADY = 'avesco_client@CONTACT_FORMREADY',
    CONTACT_FORMSUBMITTING = 'avesco_client@CONTACT_FORMSUBMITTING',
    CONTACT_FORMSUBMITTED = 'avesco_client@CONTACT_FORMSUBMITTED',
    CONTACT_FORMCANNOTSUBMIT = 'avesco_client@CONTACT_FORMCANNOTSUBMIT',

    LANGUAGE_SELECTION = 'avesco_client@LANGUAGE_SELECTION',
    CURRENCY_SELECTION = 'avesco_client@CURRENCY_SELECTION',
    DETAILPRICE_SELECTION = 'avesco_client@DETAILPRICE_SELECTION',

    PAGE_MAIN = 'avesco_client@PAGE_MAIN',
    PAGE_CATEGORY = 'avesco_client@PAGE_CATEGORY',
    PAGE_SUBCATEGORY = 'avesco_client@PAGE_SUBCATEGORY',
    PAGE_CONFIGURATION = 'avesco_client@PAGE_CONFIGURATION',
    PAGE_CONTRACT = 'avesco_client@PAGE_CONTRACT',
    PAGE_OFFER = 'avesco_client@PAGE_OFFER',
    PAGE_SPECIALOFFER = 'avesco_client@PAGE_SPECIALOFFER',
}

export const enum LinkType {
    LEASIG_SECTION = 'LEASIG_SECTION',
    RENT_SECTION = 'RENT_SECTION',
    USED_SECTION = 'USED_SECTION'
}

export const enum ApiErrorType {
    NONE = 'none',
    INVALID_CREDENTIALS = 'invalidcredentials',
    SERVER_UNAVAILABLE = 'serverunavailable'
}

export const GTM_ACCOUNT_CREATE = { event: 'Benutzerkonto Angelegt' };
export const GTM_USED = { event: 'Gebraucht'};
export const GTM_OFFER = { event: 'Kontaktformular - Beratung Anfordern'};
export const GTM_RENT = { event: 'Produkt Mieten'};
export const GTM_LEASING = { event: 'Produkt Finanzierung'};
export const GTM_CONTRACT = { event: 'Produkt Bestellt'};
export const GTM_USER_LOGIN = { event: 'User Login'};

export function gtm(dataLayer: object): void {
    try {
        TagManager.dataLayer({dataLayer: dataLayer});
    } catch (e) {
    }
}

export const DEFAULT_COUNTRIES = ["AT","EE","LT","LV","CH","|"/*,"DE","ES","FR","GB","IT","|"*/,"..."];

export const VALUE_ERROR_SUFFIX = '$error';
export const VALUE_NORMALIZED_SUFFIX = '$norm';

export const DATE_FORMAT = 'DD.MM.YYYY';

export const NATURAL_SORT_COMPARE_OPTIONS : object = {numeric: true, sensitivity: 'base'};

// The base URL for the development must be mosaletest
export const BASE_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development'?'http://localhost:8080':'');
export const URL_USED_MACHINES = 'https://www.avesco.ch/gebrauchtmaschinen.html';
export const URL_AVESCORENT = 'https://www.avescorent.ch';
export const URI_DOWNLOADOFFER = BASE_URL + '/mosale/publish?class=net.oneoverzero.mosale.persistency.AbstractPurchase&id=';

export const API_BASE_PATH = '/mosale/restv1';
export const AUTH_BASE_PATH = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development'?'https://configuratortest.avesco.ch':'') + '/mosale/fleet/rest';

const URI_LINKTOPRODUCT = BASE_URL + API_BASE_PATH + '/linktoproduct?productid=';
export function linkToProduct(productId: number) {
    return URI_LINKTOPRODUCT + productId;
}

export const NUMBER_FORMAT_DECIMAL = '0,0[.]00';

export const RENT_MONTHS = [...Array(55).keys()].splice(12);
export const FULLSERVICE_MONTHS = [...Array(61).keys()].splice(12);

const URL_PORTAL = 'https://clientportal.avesco.ch';
export function openPortal() {
    window.open(URL_PORTAL, '_self')
}
export const PORTAL_APP_VERSION = 65385;

// Rounding constants taken from net.oneoverzero.mosale.persistency.ProductForm java class
export const ROUND_NETTO_TO_NEAREST_DEFAULT: number = 50.0;
export const DIVISION_ROUNDING_THRESHOLD: number = 3000.0;
export const ROUND_BRUTTO_TO_NEAREST_SMALL_AMOUNTS: number = 10.0;

// Carousel constants
export const CAROUSEL_AUTOPLAY: boolean = true;
export const CAROUSEL_AUTOPLAYINTERVAL_MS: number = 2000;

export const enum ContactType {
    OFFER = 'offer',
    CONTRACT = 'contract',
    SUBSCRIBE = 'subscribe'
}

// Currency
export enum Currency {
    CHF = 'CHF',
    EUR = 'EUR'
}

export interface CurrencyProps {
    currency: Currency
}

export interface CurrencyAction {
    type: ActionType.CURRENCY_SELECTION,
    currency: Currency;
}

const enable_currency: string = process.env.REACT_APP_ENABLE_CURRENCY||'';
const DEFAULT_CURRENCY: Currency = Currency.CHF;
export const CURRENT_CURRENCY: Currency = enable_currency&&enable_currency!=''&&Currency[enable_currency as keyof typeof Currency]||DEFAULT_CURRENCY;

export const currencyInitialState: Currency = CURRENT_CURRENCY;

export function currencyReducer(state: Currency = currencyInitialState, action: CurrencyAction) {
    if (action && action.currency){
        return action.currency;
    }
    return state;
}

// Show detail price
export interface DetailPriceProps {
    detailPrice: boolean
}

export interface DetailPriceAction {
    type: ActionType.DETAILPRICE_SELECTION,
    detailPrice: boolean;
}

export const detailPriceInitialState: boolean = false;

export function detailPriceReducer(state: boolean = detailPriceInitialState, action: DetailPriceAction) {
    if (action && action.detailPrice) {
        return action.detailPrice;
    }
    return state;
}

const split_locale = /^(?:(en-GB-oed|i-ami|i-bnn|i-default|i-enochian|i-hak|i-klingon|i-lux|i-mingo|i-navajo|i-pwn|i-tao|i-tay|i-tsu|sgn-BE-FR|sgn-BE-NL|sgn-CH-DE)|(art-lojban|cel-gaulish|no-bok|no-nyn|zh-guoyu|zh-hakka|zh-min|zh-min-nan|zh-xiang))$|^((?:[a-z]{2,3}(?:(?:-[a-z]{3}){1,3})?)|[a-z]{4}|[a-z]{5,8})(?:-([a-z]{4}))?(?:-([a-z]{2}|\d{3}))?((?:-(?:[\da-z]{5,8}|\d[\da-z]{3}))*)?((?:-[\da-wy-z](?:-[\da-z]{2,8})+)*)?(-x(?:-[\da-z]{1,8})+)?$|^(x(?:-[\da-z]{1,8})+)$/i;
export function extractCountry(locale:string): string|undefined {
    const split: RegExpExecArray | null = split_locale.exec(locale);
    return split&&(split.length>=6)?split[5]:undefined;
}


// WEBPACK FOOTER //
// ./src/constants/index.tsx